export default __webpack_public_path__ + "static/hosting-bd5473c54935430646f04fe32775c409.mp4";